import type { PropsWithChildren } from "react";
import { memo } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const SkeletonContainer = memo(function SkeletonContainer({
  children,
}: PropsWithChildren) {
  return (
    <SkeletonTheme duration={0.8} enableAnimation>
      {children}
    </SkeletonTheme>
  );
});
